import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";
import { useFetchClientInvoiceCount, useFetchOutstandingClientAmount, useFetchClientOverdue, useFetchTotalClientPayments, useFetchTotalClientInvoices } from './ClientDashboardCurrencyApi';
import { motion } from 'framer-motion';

const ClientAmountOverview = (props) => {

    const currencySum = props.sum;
    let value = "USD";
    const dashboradDate = useSelector((state) => state.invoice.dashboardDateRange);
    const reduxCurr = useSelector(
        (state) => state.invoice.dashboardCurrency
    );
    const { appSettings } = useSelector((state) => state.appSettings);
    const { forex } = useSelector((state) => state.forex);
    const defaultCurrency = appSettings.currency;

    const dashboradCurrency = reduxCurr;

    if (dashboradCurrency) {
        value = dashboradCurrency;
    }
    const user = useSelector(
        (state) => state.auth.user
    )

    const token = useSelector(
        (state) => state.auth.token
    )


    // Use React Query to fetch invoice count
    const { data: invoiceCount, isLoading: isLoadingTatalCount, refetch: refetchTotalCount } =
        useFetchClientInvoiceCount(
            token,
            new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString(),
            new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString(),
            currencySum
        );

    // Use React Query to fetch overdue data
    const { data: overdueTotal, isLoading: isLoadingOverDueCount, refetch: refetchOverDueCount } = useFetchClientOverdue(
        token,
        new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString(),
        new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString(),
        dashboradCurrency,
        currencySum,
        forex
    );

    // Use React Query to fetch total payments
    const { data: totalInvoices, isLoading: isLoadingTotalInvoices, refetch: refetchTotalInvoices } =
        useFetchTotalClientInvoices(
            token,
            new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString(),
            new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString(),
            dashboradCurrency,
            currencySum,
            defaultCurrency,
            forex
        );

    const { data: totalPayments, isLoading: isLoadingTotalpayments, refetch: refetchTotalPayments } =
        useFetchTotalClientPayments(
            token,
            new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString(),
            new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString(),
            dashboradCurrency,
            currencySum,
            defaultCurrency,
            forex
        );

    const { data: totalOutstand, isLoading: isLoadingOutstand, refetch: refetchOutstandAmount } =
        useFetchOutstandingClientAmount(
            token,
            new Date(moment(dashboradDate[0]).tz(global.config.getTimeZone()).startOf('day')).toISOString(),
            new Date(moment(dashboradDate[1]).tz(global.config.getTimeZone()).endOf('day')).toISOString(),
            dashboradCurrency,
            currencySum,
            forex
        );

    useEffect(() => {
        refetchTotalInvoices();
        refetchTotalPayments();
        refetchOutstandAmount();
        refetchOverDueCount();
        refetchTotalCount();
    }, [forex, dashboradDate, dashboradCurrency, user, token, currencySum]);


    // new Date(moment().tz(global.config.getTimeZone()).subtract(30, 'years').startOf('year').format()).toISOString(),
    // new Date(moment().tz(global.config.getTimeZone()).endOf('year').format()).toISOString(),
    // Use React Query to fetch outstanding amount

    // useEffect(() => {
    //     refetchTotalCount();
    // }, [dashboradDate, dashboradCurrency, user, token, currencySum]);

    // Animated number component
    function AnimatedNumber({ value, currency, duration = 1000 }) {
        const [displayValue, setDisplayValue] = useState(0);
        const prevValueRef = useRef(0);

        useEffect(() => {
            if (typeof value === "number" && !isNaN(value)) {
                const startValue = prevValueRef.current;
                const endValue = value;
                const startTime = Date.now();

                const animate = () => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    // Easing function (ease-out)
                    const easeOut = 1 - Math.pow(1 - progress, 3);
                    const currentValue = startValue + (endValue - startValue) * easeOut;

                    setDisplayValue(currentValue);

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    } else {
                        setDisplayValue(endValue);
                        prevValueRef.current = endValue;
                    }
                };

                requestAnimationFrame(animate);
            } else {
                setDisplayValue(0);
                prevValueRef.current = 0;
            }
        }, [value, duration]);

        try {
            if (typeof value !== "number" || isNaN(value)) {
                return "--";
            }

            if (currency) {
                return displayValue.toLocaleString('en-US', {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            } else {
                // For non-currency numbers (like invoice count)
                return Math.round(displayValue).toLocaleString('en-US');
            }
        } catch (error) {
            console.error("Error formatting animated number:", error);
            return "--";
        }
    }

    function TotalPayment(props) {
        try {
            const { amount, currency = "USD" } = props;

            if (typeof amount !== "number" || isNaN(amount)) {
                console.warn("Invalid amount provided to TotalPayment:", amount);
                return "--";
            }

            return <AnimatedNumber value={amount} currency={currency} />;
        } catch (error) {
            console.error("Error formatting total payment:", error);
            return "--";
        }
    }

    // Skeleton loader component for numbers
    function NumberSkeleton() {
        return (
            <div
                style={{
                    width: "180px",
                    height: "40px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    display: "flex",
                    alignItems: "center",
                }}
            />
        );
    }

    const componentRef = useRef(null);
    const fadeIn = {
        hidden: { opacity: 0 , scale: 0.97},
        visible: { opacity: 1 , scale: 1}
    };

    return (
        <>
            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.5;
                    }
                }
            `}</style>
            <div className='outer-overview'>
                <div className='inner-overview'>
                    <div className='overview-item'>
                        <div className='overview-title-outer'>
                            <div className='overview-title'> <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')}</span>{global.config.locate(appSettings && appSettings.language, 'Total Invoices')}</div>
                            <div className='overview-icon'>
                                <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1227_6)">
                                        <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
                                    </g>
                                    <path d="M35.31 18.3287V36.4248C35.31 36.6549 35.1913 36.8467 34.954 36.9617C34.8749 37 34.7959 37 34.7168 37C34.5587 37 34.4397 36.9617 34.3211 36.8467L32.9368 35.6577L31.5522 36.8467C31.3149 37.0385 30.9984 37.0385 30.7611 36.8467L29.3766 35.6577L27.992 36.8467C27.7547 37.0385 27.4382 37.0385 27.2009 36.8467L25.8166 35.6577L24.432 36.8467C24.1947 37.0385 23.8783 37.0385 23.641 36.8467L22.2567 35.6577L20.8721 36.8467C20.6348 37.0385 20.3183 37.0385 20.081 36.8467L18.6964 35.6577L17.3119 36.8467C17.1538 37 16.8767 37.0385 16.6789 36.9235C16.4419 36.8467 16.3232 36.6549 16.3232 36.4248V12.5752C16.3232 12.2684 16.6003 12 16.9165 12H28.7832H28.9018C28.9413 12 28.9413 12 28.981 12.0383H29.0205C29.0599 12.0383 29.0599 12.0765 29.0996 12.0765H29.1391C29.1786 12.1148 29.2183 12.1148 29.2183 12.1533L32.185 15.03C33.8857 16.6792 34.6374 17.4081 34.9936 17.7917C35.1517 17.8685 35.2706 18.0218 35.31 18.2136C35.3098 18.2519 35.31 18.2904 35.31 18.3287ZM29.3766 13.9561V17.7534H33.2927C32.1852 16.6794 30.4841 15.03 29.3766 13.9561ZM34.1235 35.159V18.9041H28.7834C28.4669 18.9041 28.1901 18.6354 28.1901 18.3288V13.1506H17.5101V35.159L18.3012 34.4687C18.4198 34.3536 18.5384 34.3154 18.6968 34.3154C18.8549 34.3154 18.9738 34.3536 19.0925 34.4687L20.4771 35.6577L21.8617 34.4687C22.099 34.2769 22.4154 34.2769 22.6527 34.4687L24.0373 35.6577L25.4219 34.4687C25.6592 34.2769 25.9757 34.2769 26.2129 34.4687L27.5975 35.6577L28.9821 34.4687C29.2194 34.2769 29.5359 34.2769 29.7732 34.4687L31.1578 35.6577L32.5423 34.4687C32.7796 34.2769 33.0961 34.2769 33.3334 34.4687L34.1235 35.159ZM31.2816 29.2466H20.4142C20.0977 29.2466 19.821 29.5152 19.821 29.8218C19.821 30.1287 20.098 30.397 20.4142 30.397H31.2816C31.5981 30.397 31.8748 30.1284 31.8748 29.8218C31.8748 29.5152 31.5981 29.2466 31.2816 29.2466Z" fill="#6A7988" />
                                    <path d="M20.414 26H31.2814C31.5979 26 31.8747 26.2686 31.8747 26.5752C31.8747 26.8818 31.5979 27.1505 31.2814 27.1505H20.414C20.0978 27.1505 19.8208 26.8821 19.8208 26.5752C19.8208 26.2686 20.0976 26 20.414 26Z" fill="#6A7988" />
                                    <path d="M20.414 22.8495H31.2814C31.5979 22.8495 31.8747 23.1181 31.8747 23.4248C31.8747 23.7314 31.5979 24 31.2814 24H20.414C20.0978 24 19.8208 23.7316 19.8208 23.4248C19.8208 23.1181 20.0976 22.8495 20.414 22.8495Z" fill="#6A7988" />
                                    <path d="M35.31 18.3287V36.4248C35.31 36.6549 35.1913 36.8467 34.954 36.9617C34.8749 37 34.7959 37 34.7168 37C34.5587 37 34.4397 36.9617 34.3211 36.8467L32.9368 35.6577L31.5522 36.8467C31.3149 37.0385 30.9984 37.0385 30.7611 36.8467L29.3766 35.6577L27.992 36.8467C27.7547 37.0385 27.4382 37.0385 27.2009 36.8467L25.8166 35.6577L24.432 36.8467C24.1947 37.0385 23.8783 37.0385 23.641 36.8467L22.2567 35.6577L20.8721 36.8467C20.6348 37.0385 20.3183 37.0385 20.081 36.8467L18.6964 35.6577L17.3119 36.8467C17.1538 37 16.8767 37.0385 16.6789 36.9235C16.4419 36.8467 16.3232 36.6549 16.3232 36.4248V12.5752C16.3232 12.2684 16.6003 12 16.9165 12H28.7832H28.9018C28.9413 12 28.9413 12 28.981 12.0383H29.0205C29.0599 12.0383 29.0599 12.0765 29.0996 12.0765H29.1391C29.1786 12.1148 29.2183 12.1148 29.2183 12.1533L32.185 15.03C33.8857 16.6792 34.6374 17.4081 34.9936 17.7917C35.1517 17.8685 35.2706 18.0218 35.31 18.2136C35.3098 18.2519 35.31 18.2904 35.31 18.3287ZM29.3766 13.9561V17.7534H33.2927C32.1852 16.6794 30.4841 15.03 29.3766 13.9561ZM34.1235 35.159V18.9041H28.7834C28.4669 18.9041 28.1901 18.6354 28.1901 18.3288V13.1506H17.5101V35.159L18.3012 34.4687C18.4198 34.3536 18.5384 34.3154 18.6968 34.3154C18.8549 34.3154 18.9738 34.3536 19.0925 34.4687L20.4771 35.6577L21.8617 34.4687C22.099 34.2769 22.4154 34.2769 22.6527 34.4687L24.0373 35.6577L25.4219 34.4687C25.6592 34.2769 25.9757 34.2769 26.2129 34.4687L27.5975 35.6577L28.9821 34.4687C29.2194 34.2769 29.5359 34.2769 29.7732 34.4687L31.1578 35.6577L32.5423 34.4687C32.7796 34.2769 33.0961 34.2769 33.3334 34.4687L34.1235 35.159ZM31.2816 29.2466H20.4142C20.0977 29.2466 19.821 29.5152 19.821 29.8218C19.821 30.1287 20.098 30.397 20.4142 30.397H31.2816C31.5981 30.397 31.8748 30.1284 31.8748 29.8218C31.8748 29.5152 31.5981 29.2466 31.2816 29.2466Z" stroke="#6A7988" stroke-width="0.2" />
                                    <path d="M20.414 26H31.2814C31.5979 26 31.8747 26.2686 31.8747 26.5752C31.8747 26.8818 31.5979 27.1505 31.2814 27.1505H20.414C20.0978 27.1505 19.8208 26.8821 19.8208 26.5752C19.8208 26.2686 20.0976 26 20.414 26Z" stroke="#6A7988" stroke-width="0.2" />
                                    <path d="M20.414 22.8495H31.2814C31.5979 22.8495 31.8747 23.1181 31.8747 23.4248C31.8747 23.7314 31.5979 24 31.2814 24H20.414C20.0978 24 19.8208 23.7316 19.8208 23.4248C19.8208 23.1181 20.0976 22.8495 20.414 22.8495Z" stroke="#6A7988" stroke-width="0.2" />
                                    <defs>
                                        <filter id="filter0_d_1227_6" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1227_6" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1227_6" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div className={`overview-rice ${totalInvoices.length > 0 ?
                            (totalInvoices[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 8 ? 'long-string' : '') +
                            (totalInvoices[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 12 ? ' very-long-string' : '')
                            : (isLoadingTotalInvoices === true ? '' : 'long-string')}`}
                        >
                            {isLoadingTotalInvoices === true ? (
                                <NumberSkeleton />
                            ) : (
                                totalInvoices.length > 0 ? (
                                    <motion.div
                                        ref={componentRef}
                                        initial="hidden"
                                        animate="visible"
                                        variants={fadeIn}
                                        transition={{ duration: 0.18 }}
                                    >
                                        <TotalPayment currency={totalInvoices[0].currency} amount={totalInvoices[0].amount} />
                                    </motion.div>
                                ) : (
                                    isLoadingTotalInvoices === true ? (
                                        <NumberSkeleton />
                                    ) : (
                                        (new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')) + "0.00"
                                    )
                                )
                            )}
                        </div>
                    </div>

                    <div className='overview-item'>
                        <div className='overview-title-outer'>
                            <div className='overview-title'> <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')}</span>{global.config.locate(appSettings && appSettings.language, 'Total Outstanding')}</div>
                            <div className='overview-icon'>
                                <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1227_4)">
                                        <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
                                    </g>
                                    <path d="M23.7667 36H17.6615C15.8204 36 14.3242 34.4682 14.3242 32.5859V16.4141C14.3242 14.5318 15.8204 13 17.6615 13H31.4172C33.2583 13 34.7545 14.5318 34.7545 16.4141V22.1875C34.7545 22.5851 34.4403 22.9062 34.0514 22.9062C33.6625 22.9062 33.3484 22.5851 33.3484 22.1875V16.4141C33.3484 15.3247 32.4827 14.4375 31.4172 14.4375H17.6615C16.596 14.4375 15.7303 15.3247 15.7303 16.4141V32.5859C15.7303 33.6753 16.596 34.5625 17.6615 34.5625H23.7667C24.1556 34.5625 24.4698 34.8837 24.4698 35.2812C24.4698 35.6788 24.1534 36 23.7667 36Z" fill="#6A7988" />
                                    <path d="M30.0894 20.3831H20.1486C19.7543 20.3831 19.4316 20.0636 19.4316 19.6731C19.4316 19.2825 19.7543 18.963 20.1486 18.963H30.0872C30.4815 18.963 30.8041 19.2825 30.8041 19.6731C30.8064 20.0636 30.4837 20.3831 30.0894 20.3831ZM24.4054 25.3314H20.1486C19.7543 25.3314 19.4316 25.0118 19.4316 24.6213C19.4316 24.2308 19.7543 23.9113 20.1486 23.9113H24.4054C24.7997 23.9113 25.1224 24.2308 25.1224 24.6213C25.1224 25.0118 24.7997 25.3314 24.4054 25.3314ZM22.2658 30.3151H20.1486C19.7543 30.3151 19.4316 29.9956 19.4316 29.6051C19.4316 29.2145 19.7543 28.895 20.1486 28.895H22.2658C22.6601 28.895 22.9827 29.2145 22.9827 29.6051C22.9827 29.9956 22.6601 30.3151 22.2658 30.3151ZM31.2186 25.3491C32.462 25.3491 33.6315 25.8284 34.5098 26.7005C35.3903 27.5725 35.8742 28.7308 35.8742 29.9645C35.8742 31.1983 35.3903 32.3543 34.5098 33.2264C33.6315 34.0984 32.462 34.5777 31.2186 34.5777C29.9751 34.5777 28.8056 34.0984 27.9274 33.2264C27.0469 32.3543 26.563 31.196 26.563 29.9623C26.563 28.7286 27.0469 27.5703 27.9274 26.6982C28.8056 25.8284 29.9751 25.3491 31.2186 25.3491ZM31.2186 23.929C27.8557 23.929 25.1291 26.6317 25.1291 29.9645C25.1291 33.2974 27.8557 36 31.2186 36C34.5815 36 37.3081 33.2974 37.3081 29.9645C37.3081 26.6317 34.5815 23.929 31.2186 23.929Z" fill="#6A7988" />
                                    <path d="M33.5674 29.5555H31.1652C30.6967 29.5555 30.3135 29.9389 30.3135 30.4074C30.3135 30.8759 30.6967 31.2592 31.1652 31.2592H33.57C34.0385 31.2592 34.4217 30.8759 34.4217 30.4074C34.4217 29.9389 34.0358 29.5555 33.5674 29.5555Z" fill="#6A7988" />
                                    <path d="M31.1647 27C30.6965 27 30.3135 27.3194 30.3135 27.7099V30.5494C30.3135 30.9398 30.6965 31.2593 31.1647 31.2593C31.6329 31.2593 32.016 30.9398 32.016 30.5494V27.7099C32.016 27.3194 31.6329 27 31.1647 27Z" fill="#6A7988" />
                                    <defs>
                                        <filter id="filter0_d_1227_4" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1227_4" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1227_4" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div className={`overview-rice ${totalOutstand.length > 0 ?
                            (totalOutstand[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 8 ? 'long-string' : '') +
                            (totalOutstand[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 12 ? ' very-long-string' : '')
                            : (isLoadingOutstand === true ? '' : 'long-string')}`}
                        >
                            {isLoadingOutstand === true ? (
                                <NumberSkeleton />
                            ) : (
                                <motion.div
                                    ref={componentRef}
                                    initial="hidden"
                                    animate="visible"
                                    variants={fadeIn}
                                    transition={{ duration: 0.18 }}
                                >
                                    {
                                        totalOutstand.length > 0 ?
                                            (
                                                <AnimatedNumber
                                                    value={totalOutstand[0].amount}
                                                    currency={value}
                                                />
                                            )
                                            :
                                            isLoadingOutstand === true ?
                                                (<NumberSkeleton />)
                                                :
                                                (new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')) + "0.00"
                                    }
                                </motion.div>
                            )}
                        </div>
                    </div>

                    <div className='overview-item'>
                        <div className='overview-title-outer'>
                            <div className='overview-title'> <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')}</span>{global.config.locate(appSettings && appSettings.language, 'Total Overdue')}</div>
                            <div className='overview-icon'>
                                <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1227_5)">
                                        <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
                                    </g>
                                    <path d="M25.0253 25.8972V18.2212C25.0253 17.8847 24.8456 17.5736 24.5546 17.4057C24.2636 17.2372 23.9043 17.2372 23.6133 17.4057C23.3222 17.5736 23.1426 17.8847 23.1426 18.2212V25.8972C23.1426 26.2336 23.3222 26.5447 23.6133 26.7132C23.9043 26.8817 24.2636 26.8811 24.5546 26.7132C24.8456 26.5453 25.0253 26.2341 25.0253 25.8972Z" fill="#6A7988" stroke="white" stroke-width="0.3" />
                                    <path d="M22.5494 30.5022C22.5494 30.9091 22.7107 31.2999 22.9985 31.5874C23.2863 31.8754 23.6763 32.0368 24.083 32.0368C24.4896 32.0368 24.8801 31.8754 25.1674 31.5874C25.4552 31.2994 25.6166 30.9091 25.6166 30.5022C25.6166 30.0952 25.4552 29.7044 25.1674 29.417C24.8796 29.129 24.4896 28.967 24.083 28.967C23.6763 28.967 23.2858 29.129 22.998 29.417C22.7102 29.705 22.5488 30.0952 22.5488 30.5027L22.5494 30.5022Z" fill="#6A7988" stroke="white" stroke-width="0.3" />
                                    <path d="M24.0837 38C20.4802 38 17.0924 36.5956 14.5443 34.0457C11.9962 31.4959 10.5928 28.1063 10.5928 24.5003C10.5928 20.8943 11.9962 17.5041 14.5443 14.9543C17.0924 12.4044 20.4802 11 24.0837 11C27.6872 11 31.0749 12.4044 33.623 14.9543C36.1711 17.5041 37.5746 20.8943 37.5746 24.5003C37.5746 28.1063 36.1711 31.4964 33.623 34.0463C31.0749 36.5961 27.6872 38.0005 24.0837 38.0005V38ZM24.0837 12.884C20.9831 12.884 18.0682 14.0925 15.8756 16.2865C13.6831 18.4806 12.4755 21.3976 12.4755 24.5003C12.4755 27.603 13.6831 30.5199 15.8756 32.714C18.0682 34.9081 20.9831 36.1165 24.0837 36.1165C27.1842 36.1165 30.0992 34.9081 32.2917 32.714C34.4842 30.5199 35.6919 27.603 35.6919 24.5003C35.6919 21.3976 34.4842 18.4806 32.2917 16.2865C30.0992 14.0925 27.1842 12.884 24.0837 12.884Z" fill="#6A7988" stroke="white" stroke-width="0.3" />
                                    <defs>
                                        <filter id="filter0_d_1227_5" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1227_5" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1227_5" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div className={`overview-rice ${overdueTotal.length > 0 ?
                            (overdueTotal[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 8 ? 'long-string' : '') +
                            (overdueTotal[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 12 ? ' very-long-string' : '')
                            : (isLoadingOverDueCount === true ? '' : 'long-string')}`}
                        >
                            {isLoadingOverDueCount === true ? (
                                <NumberSkeleton />
                            ) : (overdueTotal.length > 0 ?
                                <motion.div
                                    ref={componentRef}
                                    initial="hidden"
                                    animate="visible"
                                    variants={fadeIn}
                                    transition={{ duration: 0.18 }}
                                >
                                    <AnimatedNumber
                                        value={overdueTotal[0].amount}
                                        currency={value}
                                    />
                                </motion.div>
                                :
                                isLoadingOverDueCount === true ?
                                    (<NumberSkeleton />)
                                    :
                                    (new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')) + "0.00"
                            )}

                        </div>
                    </div>

                    <div className='overview-item'>
                        <div className='overview-title-outer'>

                            <div className={`overview-title ${new Intl.NumberFormat('en-US', { style: 'currency', currency: value }).format(0).replace(/[\d.,]/g, '').length === 3 ? 'three-character-currency' : ''}`}>
                                <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: value }).format(0).replace(/[\d.,]/g, '')}</span>{global.config.locate(appSettings && appSettings.language, 'Total Payments')}
                            </div>
                            <div className='overview-icon'>
                                <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1227_3)">
                                        <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
                                    </g>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0819 36.7337C21.6638 36.7337 19.3002 36.016 17.2894 34.6717C15.2788 33.3271 13.7117 31.4161 12.7863 29.1802C11.8608 26.9443 11.6186 24.4838 12.0902 22.1103C12.562 19.7365 13.7264 17.556 15.4361 15.8446C17.1459 14.1332 19.3243 12.9677 21.6961 12.4955C24.0677 12.0232 26.526 12.2656 28.7597 13.1916C30.9936 14.1178 32.9032 15.6863 34.2467 17.6986C35.59 19.711 36.3072 22.0769 36.3072 24.4972C36.3034 27.7413 35.0143 30.8515 32.7226 33.1457C30.4307 35.4397 27.3231 36.7297 24.0819 36.7337ZM24.4717 11H23.6922C20.1496 11.1028 16.7898 12.5969 14.339 15.1592C11.8881 17.7212 10.5429 21.1459 10.5942 24.6928C10.6456 28.2398 12.0895 31.6238 14.6135 34.114C17.1377 36.6041 20.5394 38 24.0837 38C27.6276 38 31.0292 36.6041 33.5533 34.114C36.0773 31.6242 37.5212 28.2398 37.5726 24.6928C37.6239 21.1461 36.2789 17.7211 33.8278 15.1592C31.377 12.5969 28.0174 11.1028 24.4746 11H24.4717ZM27.7132 28.0211C27.7132 26.6252 26.3941 25.4232 24.7153 25.1768V30.848C26.4267 30.568 27.7132 29.4074 27.7132 28.0211ZM20.4513 20.9725C20.4513 22.3681 21.7705 23.5707 23.4493 23.8167V18.1456C21.7375 18.4257 20.4513 19.5858 20.4513 20.9725ZM27.7844 19.9222C27.945 20.2326 28.3266 20.3541 28.6367 20.1932C28.9468 20.0325 29.068 19.6506 28.9075 19.3402C28.175 17.9242 26.5601 16.9718 24.7149 16.8332V15.4134C24.7185 15.2432 24.6535 15.0786 24.5345 14.9569C24.4155 14.8352 24.2526 14.7666 24.0824 14.7666C23.9123 14.7666 23.7492 14.8352 23.6302 14.9569C23.5112 15.0786 23.4463 15.2432 23.45 15.4134V16.867C22.4559 16.9843 21.5129 17.3708 20.722 17.9847C19.7742 18.6879 19.2064 19.7919 19.1851 20.9724C19.207 22.145 19.7626 23.2434 20.6944 23.9549C21.4844 24.5907 22.4406 24.9859 23.4488 25.0932V30.8911C22.0904 30.7595 20.8912 30.0619 20.3793 29.0725C20.2186 28.7621 19.837 28.6406 19.5268 28.8015C19.2167 28.9621 19.0955 29.3441 19.2563 29.6545C19.9887 31.0704 21.6032 32.0231 23.4488 32.1619V33.5814C23.4564 33.9256 23.7373 34.2008 24.0812 34.2008C24.4253 34.2008 24.7062 33.9256 24.7138 33.5814V32.1265C25.7075 32.0084 26.6505 31.6221 27.4418 31.0086C28.4007 30.3201 28.9719 29.2129 28.9772 28.0314C28.9828 26.8501 28.4222 25.7376 27.4696 25.0398C26.6795 24.4035 25.7233 24.0076 24.7149 23.8997V18.1038C26.0736 18.2354 27.2721 18.9329 27.7844 19.9222Z" fill="#6A7988" stroke="white" stroke-width="0.2" />
                                    <defs>
                                        <filter id="filter0_d_1227_3" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1227_3" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1227_3" result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div className={`overview-rice ${totalPayments.length > 0 ?
                            (totalPayments[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 8 ? 'long-string' : '') +
                            (totalPayments[0].amount.toLocaleString('en-US', { style: 'currency', currency: value }).replace(/[^\d.]/g, '').length > 12 ? ' very-long-string' : '')
                            : (isLoadingTotalpayments === true ? '' : 'long-string')}`}
                        >
                            {isLoadingTotalpayments === true ? (
                                <NumberSkeleton />
                            ) : (
                                totalPayments.length > 0 ? (
                                    <motion.div
                                        ref={componentRef}
                                        initial="hidden"
                                        animate="visible"
                                        variants={fadeIn}
                                        transition={{ duration: 0.18 }}
                                    >
                                        <TotalPayment currency={totalPayments[0].currency} amount={totalPayments[0].amount} />
                                    </motion.div>
                                ) : (
                                    isLoadingTotalpayments === true ? (
                                        <NumberSkeleton />
                                    ) : (
                                        (new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')) + "0.00"
                                    )
                                )
                            )}
                        </div>
                        {/* <div className={`overview-rice ${isLoadingTatalCount === true ? '' : (invoiceCount[dashboradCurrency] ? (invoiceCount[dashboradCurrency].toString().replace(/[^\d.]/g, '').length > 8 ? 'long-string' : '') + (invoiceCount[dashboradCurrency] && invoiceCount[dashboradCurrency].toString().replace(/[^\d.]/g, '').length > 12 ? ' very-long-string' : '') : '')}`}>
                        {isLoadingTatalCount === true ?
                            (
                                
                            ) :
                            // (currencySum ===false) ? invoiceCount[dashboradCurrency] && invoiceCount[dashboradCurrency] : Object.values(invoiceCount).reduce((acc, value) => acc + value, 0)
                            <motion.div
                                ref={componentRef}
                                initial="hidden"
                                animate="visible"
                                variants={fadeIn}
                                transition={{ duration: 0.18 }}
                            >
                                {currencySum === false
                                    ? (invoiceCount[dashboradCurrency] !== undefined ? invoiceCount[dashboradCurrency] : "0")
                                    : Object.values(invoiceCount).reduce((acc, value) => acc + value, 0) || "0"
                                }</motion.div>
                        }
                    </div> */}
                    </div>

                </div>
            </div>
        </>
    );
};

export default ClientAmountOverview;